import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbNav,
  NgbNavChangeEvent,
} from '@ng-bootstrap/ng-bootstrap';
import { CommonComponent } from '@components/abstract/common-component.component';
import { CoreMediaService } from '@services/common/media.service';
import { Media } from '@models/media/media.model';
import { base64ToFile2 } from '@functions/files';

@Component({
  selector: 'app-gallery-rotate-crop',
  templateUrl: './gallery-rotate-crop.component.html',
  styleUrls: ['./gallery-rotate-crop.component.scss'],
  styles: [],
})
export class GalleryRotateCropComponent extends CommonComponent {
  @ViewChild('outlet', { static: true }) outlet: NgbNav;

  modal = inject(NgbActiveModal);
  private service = inject(CoreMediaService);
  @Output() emitter = new EventEmitter<File | Media>();

  active = 1;
  disabled = true;
  file: File | undefined = undefined;
  media: Media;

  constructor() {
    super();
  }

  async onSelect(media: Media) {
    if (media) {
      this.media = media;
      const base = await this.service.getBase64Image(`${media.url}`);
      if (base) {
        base64ToFile2(`${base}`, `${media.name}`, 'image/jpg').then(file => {
          if (file) {
            this.file = file;
            this.outlet.select(3);
            this.active = 3;
            this.disabled = false;
          }
        });
      }
    }
  }

  navChange($event: NgbNavChangeEvent<any>) {
    this.active = $event.activeId;
    this.disabled = $event.activeId !== 3;
    if ($event.activeId !== 3) {
      this.file = undefined;
    }
  }

  onKeep() {
    this.emitter.emit(this.media);
  }
}
